export default {"src":"/_next/static/media/0x0f5d2fb29fb7d3cfee444a200298f468908cc942.1b81a607.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};